"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const CarouselSlideAddButton_1 = tslib_1.__importDefault(require("../../../ui-lib/Carousel/CarouselSlideAddButton"));
const StartPlayerButton = (0, mobx_react_lite_1.observer)(({ classes, publicKey }) => {
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<AddPlayerButton/>");
    if (ctx != null && publicKey != null && !(ctx === null || ctx === void 0 ? void 0 : ctx.activePublicKeys.includes(publicKey))) {
        return react_1.default.createElement(CarouselSlideAddButton_1.default, { onClick: () => ctx.startPlayer(publicKey), classes: classes });
    }
    return null;
});
/**
 *
 * @visibleName Add Player Button
 */
// eslint-disable-next-line react/function-component-definition
const StartPlayerButtonWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(CarouselSlideAddButton_1.default, { classes: classes, onClick: undefined, ...props }) },
        react_1.default.createElement(StartPlayerButton, { classes: classes, ...props })));
};
exports.default = StartPlayerButtonWithErrorBoundary;
//# sourceMappingURL=StartPlayerButton.js.map